<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <BitQLoginPage :service_title="service_title" :showcase_id="showcase_id"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import BitQLoginPage from '@/components/bitq/BitQLoginPage'

export default {
  name: 'BitQGaming',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Gaming", link : 'conv-bitq-gaming' } ],

        // Nome welfarebit del servizio
        service_title : "Gaming",

        // Identificativo della vetrina ( fornito da BitQ )
        showcase_id : 150
    }
  },
  components: {
    PageTagline,
    BitQLoginPage
  }
}
</script>

<style scoped></style>